export const GET_ORDER_TRACKING_REQUEST = 'cash/GET_ORDER_TRACKING_REQUEST';
export const GET_ORDER_TRACKING_SUCCESS = 'cash/GET_ORDER_TRACKING_SUCCESS';
export const GET_ORDER_TRACKING_FAILURE = 'cash/GET_ORDER_TRACKING_FAILURE';

export const ON_SELECT_ORDER = 'cash/ON_SELECT_ORDER';

export const POST_ORDER_META_REQUEST = 'cash/POST_ORDER_META_REQUEST';
export const POST_ORDER_META_SUCCESS = 'cash/POST_ORDER_META_SUCCESS';
export const POST_ORDER_META_FAILURE = 'cash/POST_ORDER_META_FAILURE';